import Box from '@mui/material/Box'
import Switch from '@mui/material/Switch'
import {
  surveyYesNoToggleLabelSx,
  surveyYesNoToggleRowSx,
} from '../../../styles/surveyExecutionStyles'

interface YesNoToggleControlProps {
  readonly yesLabel: string
  readonly noLabel: string
  readonly value: 'yes' | 'no' | null
  readonly onChange: (value: 'yes' | 'no') => void
  readonly questionId: string
}

export function YesNoToggleControl({
  yesLabel,
  noLabel,
  value,
  onChange,
  questionId,
}: YesNoToggleControlProps) {
  const checked = value === 'yes'

  return (
    <Box
      sx={surveyYesNoToggleRowSx}
      data-testid={`survey-q-${questionId}-yes-no-toggle`}
    >
      <Box component="span" sx={surveyYesNoToggleLabelSx}>
        {noLabel}
      </Box>
      <Switch
        checked={checked}
        onChange={(_, next) => onChange(next ? 'yes' : 'no')}
        data-testid={`survey-q-${questionId}-toggle-input`}
        inputProps={{
          'aria-label': `${yesLabel} or ${noLabel}`,
        }}
      />
      <Box component="span" sx={surveyYesNoToggleLabelSx}>
        {yesLabel}
      </Box>
    </Box>
  )
}
